var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgIcebergAnimal5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00cdda;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg-iceberg-animal5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M19.47,7.05A8.74,8.74,0,0,1,19,2.74c-1.46-.19-2.35,2.69-2.38,5.07A7.67,7.67,0,0,0,9.15,2.35c-4.26.07-7.42,3.94-7.48,6.31v.06C1.67,13,5.36,15,9.65,15c4,0,6.69-1.5,7.15-5.28a3.82,3.82,0,0,0,1.94,1.65,4.17,4.17,0,0,0,3.37-.42,6.88,6.88,0,0,1-2.64-3.87ZM4.68,8.69a1,1,0,1,1,1-1,1,1,0,0,1-1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-1",
    d: "M64.06,58a8.89,8.89,0,0,1,.54-4.3c-1.37-.52-2.9,2.09-3.47,4.39a7.66,7.66,0,0,0-6-7c-4.17-.92-8.13,2.13-8.73,4.43v0c-1,4.12,2.16,6.94,6.33,7.92,3.89.91,6.86.06,8.17-3.51a3.84,3.84,0,0,0,1.51,2,4.13,4.13,0,0,0,3.38.36A6.8,6.8,0,0,1,64.06,58ZM49.29,56.21a1,1,0,1,1,1.23-.76,1,1,0,0,1-1.23.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-1",
    d: "M87.84,24.56A4.78,4.78,0,0,1,86,27.26a2.92,2.92,0,0,0,2.35.29A2.64,2.64,0,0,0,89.7,26.4c.32,2.64,2.2,3.69,5,3.69,3,0,5.56-1.41,5.56-4.37v0c0-1.66-2.24-4.36-5.21-4.4a5.34,5.34,0,0,0-5.22,3.8c0-1.65-.64-3.67-1.65-3.53a6.2,6.2,0,0,1-.32,3Zm10.31,1.15a.72.72,0,1,1,.71-.72.72.72,0,0,1-.71.72Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    className: "cls-1",
    cx: 46.93,
    cy: 35.91,
    r: 1.74
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-2",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 34.73,
    cy: 28.94,
    r: 1.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-3",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 42.86,
    cy: 24.29,
    r: 1.16
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-4",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 44.9,
    cy: 11.8,
    r: 0.87
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-5",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 41.41,
    cy: 47.82,
    r: 1.45
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcebergAnimal5);
export default __webpack_public_path__ + "static/media/bg-iceberg-animal5.ddb5e8fc33a2b2366411f09844242288.svg";
export { ForwardRef as ReactComponent };